import React from "react";
import * as Alert from "./Alerts";

const Footer = () => (
  <footer className="w-full pin-b border-t border-grey">
    <div className="container mx-auto px-4 mt-6">
      <h2 className="font-hairline">Footer</h2>
      <Alert.Basic text="It's the footer." />
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js